import { ExclamationCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './Dialog.module.css';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  icon?: 'warning';
  title: string;
  children: React.ReactNode;
  buttons: React.ReactNode;
}

const DialogIcon = ({ icon }: { icon: Props['icon'] }) => {
  switch (icon) {
    case 'warning':
      return (
        <ExclamationCircleOutlined
          className={styles.icon}
          style={{ color: '#FAAD14' }}
        />
      );
    default:
      return null;
  }
};
export const Dialog: FunctionComponent<Props> = ({
  className,
  style,
  icon,
  title,
  children,
  buttons,
}) => {
  return (
    <div className={classNames(styles.container, className)} style={style}>
      <DialogIcon icon={icon} />
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        <div className={styles.content}>{children}</div>
        <div className={styles.buttons}>{buttons}</div>
      </div>
    </div>
  );
};
